<template>
    <div>
        <b-breadcrumb :items="items"/>
        <form class="container-fluid" style="background-color: white">
            <div class="row mt-2">
                <table width="100%" class="table">
                    <thead>
                    <tr>
                        <th>วันที่สร้าง DO</th>
                        <th>รหัสสินค้า</th>
                        <th>DO</th>
                        <th>จำนวนจอง DO</th>
                        <th>TN</th>
                        <th>จำนวนขายจริง</th>
                        <th>รหัสโควต้าที่ใช้</th>
                        <th>โควต้าคงเหลือ</th>
                        <th>โควต้าหมดอายุ</th>
                        <th>หมายเหตุ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(x,i) in list" :key="i">
                        <td>{{x.order.date | moment('DD/MM/YYYY')}}</td>
                        <td>{{x.product.sku}}</td>
                        <td>{{x.order.order_id}}</td>
                        <td>{{x.order_used}}</td>
                        <td>{{x.invoice ? x.invoice.invoice_id : '-'}}</td>
                        <td>{{x.invoice_used ? x.invoice_used : '-'}}</td>
                        <td>
                            <template v-if="x.quota_no_used">
                                <template v-for="(u,i) in x.quota_no_used.split(',')">
                                    {{u}} ({{x.quota_used.split(',')[i]+' ชิ้น'}}) <br>
                                </template>
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="x.quota_no_left">
                                <template v-for="(u,i) in x.quota_no_left.split(',')">
                                    {{u}} ({{x.quota_left.split(',')[i]+' ชิ้น'}}) <br>
                                </template>
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="x.quota_no_expire">
                                <template v-for="(u,i) in x.quota_no_expire.split(',')">
                                    {{u}} ({{x.quota_expire.split(',')[i]+' ชิ้น'}}) <br>
                                </template>
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            {{ x.reason?x.reason:'-' }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </form>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";

export default {
    name: "quota-history",
    components: {
        Multiselect
    },
    created() {
        this.$store.dispatch('Seller/quotaSaleHistory',this.$route.params.id).then(res=>{
            this.list = res
        });
    },
    data() {
        return {
            items: [
                {
                    text: "ตั้งค่าโควต้า",
                    to: {name: "quota-config"}
                },
                {
                    text: "รายละเอียด",
                    active: true
                }
            ],
            list: [],
        }
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
        }),
    },
    methods: {

    }

}
</script>

<style scoped>
.text-bold {
    font-weight: bold;
}

thead tr {
    background-color: #ffbf00;
    color: white;
}

thead td {
    color: black;
    background-color: #ebebe0;
}
tbody tr td{
    vertical-align: top;
}
</style>
